/**
 * Local seed data for the bookshelf feature.
 * Mirrors the titles already used on Home (src/data.js) for continuity,
 * extended with the fields the bookshelf needs (status, genres, progress,
 * shelves). Stands in for the eventual API response.
 */

const DAY = 24 * 60 * 60 * 1000;
const now = Date.now();

export const SEED_BOOKS = [
  {
    id: 'book_night_circus',
    title: 'The Night Circus',
    author: 'Erin Morgenstern',
    tone: 'coral',
    genres: ['Fantasy', 'Romance'],
    status: 'reading',
    isFavorite: true,
    rating: null,
    totalPages: 400,
    currentPage: 248,
    dateAdded: now - 40 * DAY,
    dateStarted: now - 12 * DAY,
    notes: 'The circus tents themselves feel like a character.',
    friendsReading: 3,
  },
  {
    id: 'book_babel',
    title: 'Babel',
    author: 'R.F. Kuang',
    tone: 'yellow',
    genres: ['Fantasy', 'Historical Fiction'],
    status: 'reading',
    isFavorite: false,
    rating: null,
    totalPages: 620,
    currentPage: 210,
    dateAdded: now - 21 * DAY,
    dateStarted: now - 9 * DAY,
    friendsReading: 1,
  },
  {
    id: 'book_piranesi',
    title: 'Piranesi',
    author: 'Susanna Clarke',
    tone: 'blue',
    genres: ['Fantasy', 'Literary Fiction'],
    status: 'reading',
    isFavorite: true,
    rating: null,
    totalPages: 220,
    currentPage: 178,
    dateAdded: now - 15 * DAY,
    dateStarted: now - 6 * DAY,
  },
  {
    id: 'book_circe',
    title: 'Circe',
    author: 'Madeline Miller',
    tone: 'yellow',
    genres: ['Fantasy', 'Classics'],
    status: 'finished',
    isFavorite: true,
    rating: 5,
    totalPages: 393,
    currentPage: 393,
    dateAdded: now - 120 * DAY,
    dateStarted: now - 118 * DAY,
    dateFinished: now - 110 * DAY,
    friendsReading: 2,
  },
  {
    id: 'book_cerulean_sea',
    title: 'The House in the Cerulean Sea',
    author: 'TJ Klune',
    tone: 'sage',
    genres: ['Fantasy', 'Contemporary'],
    status: 'finished',
    isFavorite: true,
    rating: 4.8,
    totalPages: 398,
    currentPage: 398,
    dateAdded: now - 96 * DAY,
    dateStarted: now - 94 * DAY,
    dateFinished: now - 88 * DAY,
  },
  {
    id: 'book_legends_lattes',
    title: 'Legends & Lattes',
    author: 'Travis Baldree',
    tone: 'coral',
    genres: ['Fantasy', 'Comedy'],
    status: 'finished',
    isFavorite: false,
    rating: 4.6,
    totalPages: 304,
    currentPage: 304,
    dateAdded: now - 70 * DAY,
    dateStarted: now - 68 * DAY,
    dateFinished: now - 63 * DAY,
  },
  {
    id: 'book_study_drowning',
    title: 'A Study in Drowning',
    author: 'Ava Reid',
    tone: 'blue',
    genres: ['Fantasy', 'Mystery'],
    status: 'finished',
    isFavorite: false,
    rating: 4.5,
    totalPages: 372,
    currentPage: 372,
    dateAdded: now - 55 * DAY,
    dateStarted: now - 53 * DAY,
    dateFinished: now - 48 * DAY,
  },
  {
    id: 'book_fourth_wing',
    title: 'Fourth Wing',
    author: 'Rebecca Yarros',
    tone: 'coral',
    genres: ['Fantasy', 'Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 512,
    dateAdded: now - 8 * DAY,
    friendsReading: 5,
  },
  {
    id: 'book_yellowface',
    title: 'Yellowface',
    author: 'R.F. Kuang',
    tone: 'yellow',
    genres: ['Fiction', 'Literary Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 336,
    dateAdded: now - 6 * DAY,
  },
  {
    id: 'book_silent_patient',
    title: 'The Silent Patient',
    author: 'Alex Michaelides',
    tone: 'blue',
    genres: ['Mystery', 'Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 336,
    dateAdded: now - 4 * DAY,
  },
  {
    id: 'book_hail_mary',
    title: 'Project Hail Mary',
    author: 'Andy Weir',
    tone: 'sage',
    genres: ['Science Fiction', 'Adventure'],
    status: 'tbr',
    isFavorite: true,
    rating: null,
    totalPages: 496,
    dateAdded: now - 2 * DAY,
    friendsReading: 4,
  },
  {
    id: 'book_it_starts_with_us',
    title: 'It Starts With Us',
    author: 'Colleen Hoover',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 336,
    dateAdded: now - 138 * DAY,
  },
  {
    id: 'book_a_curse_so_dark_and_lonely',
    title: 'A Curse So Dark And Lonely',
    author: 'Brigid Kemmerer',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 496,
    dateAdded: now - 137 * DAY,
  },
  {
    id: 'book_a_week_in_winter',
    title: 'A Week In Winter',
    author: 'Maeve Binchy',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 560,
    dateAdded: now - 136 * DAY,
  },
  {
    id: 'book_even_when_you_lie_to_me',
    title: 'Even When You Lie To Me',
    author: 'Kate Stewart',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 135 * DAY,
  },
  {
    id: 'book_the_maidens',
    title: 'The Maidens',
    author: 'Alex Michaelides',
    tone: 'blue',
    genres: ['Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 352,
    dateAdded: now - 134 * DAY,
  },
  {
    id: 'book_the_psychology_of_money',
    title: 'The Psychology of Money',
    author: 'Morgan Housel',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 256,
    dateAdded: now - 133 * DAY,
  },
  {
    id: 'book_think_like_a_monk',
    title: 'Think Like A Monk',
    author: 'Jay Shetty',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 336,
    dateAdded: now - 132 * DAY,
  },
  {
    id: 'book_autobiography_of_a_yogi',
    title: 'Autobiography of A Yogi',
    author: 'Paramahansa Yogananda',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 528,
    dateAdded: now - 131 * DAY,
  },
  {
    id: 'book_the_book_of_rumi',
    title: 'The Book of Rumi',
    author: 'Rumi',
    tone: 'yellow',
    genres: ['Poetry'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 224,
    dateAdded: now - 130 * DAY,
  },
  {
    id: 'book_marriage_for_one',
    title: 'Marriage For One',
    author: 'Ella Maise',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 380,
    dateAdded: now - 129 * DAY,
  },
  {
    id: 'book_destroy_me',
    title: 'Destroy Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 128,
    dateAdded: now - 128 * DAY,
  },
  {
    id: 'book_unravel_me',
    title: 'Unravel Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 368,
    dateAdded: now - 127 * DAY,
  },
  {
    id: 'book_fracture_me',
    title: 'Fracture Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 96,
    dateAdded: now - 126 * DAY,
  },
  {
    id: 'book_ignite_me',
    title: 'Ignite Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 416,
    dateAdded: now - 125 * DAY,
  },
  {
    id: 'book_restore_me',
    title: 'Restore Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 368,
    dateAdded: now - 124 * DAY,
  },
  {
    id: 'book_shadow_me',
    title: 'Shadow Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 96,
    dateAdded: now - 123 * DAY,
  },
  {
    id: 'book_defy_me',
    title: 'Defy Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 352,
    dateAdded: now - 122 * DAY,
  },
  {
    id: 'book_reveal_me',
    title: 'Reveal Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 112,
    dateAdded: now - 121 * DAY,
  },
  {
    id: 'book_imagine_me',
    title: 'Imagine Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 384,
    dateAdded: now - 120 * DAY,
  },
  {
    id: 'book_believe_me',
    title: 'Believe Me',
    author: 'Tahereh Mafi',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 112,
    dateAdded: now - 119 * DAY,
  },
  {
    id: 'book_murakami',
    title: 'Murakami',
    author: 'Haruki Murakami',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 118 * DAY,
  },
  {
    id: 'book_spanish_love_deception',
    title: 'Spanish Love Deception',
    author: 'Elena Armas',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 464,
    dateAdded: now - 117 * DAY,
  },
  {
    id: 'book_happy_place',
    title: 'Happy Place',
    author: 'Emily Henry',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 116 * DAY,
  },
  {
    id: 'book_all_the_dangerous_things',
    title: 'All the Dangerous Things',
    author: 'Stacy Willingham',
    tone: 'blue',
    genres: ['Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 336,
    dateAdded: now - 115 * DAY,
  },
  {
    id: 'book_icebreaker',
    title: 'Icebreaker',
    author: 'Hannah Grace',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 384,
    dateAdded: now - 114 * DAY,
  },
  {
    id: 'book_the_wall_of_winnipeg_and_me',
    title: 'The Wall of Winnipeg and Me',
    author: 'Mariana Zapata',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 560,
    dateAdded: now - 113 * DAY,
  },
  {
    id: 'book_the_deal',
    title: 'The Deal',
    author: 'Elle Kennedy',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 328,
    dateAdded: now - 112 * DAY,
  },
  {
    id: 'book_the_spanish_deception_of_love',
    title: 'The Spanish Deception of Love',
    author: 'Elena Armas',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 464,
    dateAdded: now - 111 * DAY,
  },
  {
    id: 'book_the_fine_print',
    title: 'The Fine Print',
    author: 'Lauren Asher',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 110 * DAY,
  },
  {
    id: 'book_terms_conditions',
    title: 'Terms & Conditions',
    author: 'Lauren Asher',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 416,
    dateAdded: now - 109 * DAY,
  },
  {
    id: 'book_final_offer',
    title: 'Final Offer',
    author: 'Lauren Asher',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 432,
    dateAdded: now - 108 * DAY,
  },
  {
    id: 'book_collided',
    title: 'Collided',
    author: 'K. Bromberg',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 107 * DAY,
  },
  {
    id: 'book_redeemed',
    title: 'Redeemed',
    author: 'K. Bromberg',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 106 * DAY,
  },
  {
    id: 'book_throttled',
    title: 'Throttled',
    author: 'K. Bromberg',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 105 * DAY,
  },
  {
    id: 'book_wrecked',
    title: 'Wrecked',
    author: 'K. Bromberg',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 104 * DAY,
  },
  {
    id: 'book_a_million_kisses_in_your_lifetime',
    title: 'A Million Kisses in Your Lifetime',
    author: 'Elsie Silver',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 432,
    dateAdded: now - 103 * DAY,
  },
  {
    id: 'book_a_recipe_for_love',
    title: 'A Recipe for Love',
    author: '',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 102 * DAY,
  },
  {
    id: 'book_the_hating_game',
    title: 'The Hating Game',
    author: 'Sally Thorne',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 384,
    dateAdded: now - 101 * DAY,
  },
  {
    id: 'book_an_irish_promise',
    title: 'An Irish Promise',
    author: '',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 100 * DAY,
  },
  {
    id: 'book_king_of_wrath',
    title: 'King of Wrath',
    author: 'Ana Huang',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 384,
    dateAdded: now - 99 * DAY,
  },
  {
    id: 'book_king_of_pride',
    title: 'King of Pride',
    author: 'Ana Huang',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 416,
    dateAdded: now - 98 * DAY,
  },
  {
    id: 'book_a_court_of_thrones_and_roses',
    title: 'A Court of Thrones and Roses',
    author: 'Sarah J. Maas',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 432,
    dateAdded: now - 97 * DAY,
  },
  {
    id: 'book_a_court_of_mist_and_fury',
    title: 'A Court of Mist and Fury',
    author: 'Sarah J. Maas',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 624,
    dateAdded: now - 96 * DAY,
  },
  {
    id: 'book_a_court_of_wings_and_ruin',
    title: 'A Court of Wings and Ruin',
    author: 'Sarah J. Maas',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 699,
    dateAdded: now - 95 * DAY,
  },
  {
    id: 'book_a_court_of_frost_and_starlight',
    title: 'A Court of Frost and Starlight',
    author: 'Sarah J. Maas',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 224,
    dateAdded: now - 94 * DAY,
  },
  {
    id: 'book_a_court_of_silver_flames',
    title: 'A Court of Silver Flames',
    author: 'Sarah J. Maas',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 768,
    dateAdded: now - 93 * DAY,
  },
  {
    id: 'book_gone_girl',
    title: 'Gone Girl',
    author: 'Gillian Flynn',
    tone: 'blue',
    genres: ['Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 432,
    dateAdded: now - 92 * DAY,
  },
  {
    id: 'book_to_love_jason_thorn',
    title: 'To Love Jason Thorn',
    author: 'Ella Maise',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 91 * DAY,
  },
  {
    id: 'book_stories_we_never_tell',
    title: 'Stories We Never Tell',
    author: 'Savi Sharma',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 250,
    dateAdded: now - 90 * DAY,
  },
  {
    id: 'book_archer_s_voice',
    title: 'Archer\'s Voice',
    author: 'Mia Sheridan',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 350,
    dateAdded: now - 89 * DAY,
  },
  {
    id: 'book_the_american_roommate_experiment',
    title: 'The American Roommate Experiment',
    author: 'Elena Armas',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 432,
    dateAdded: now - 88 * DAY,
  },
  {
    id: 'book_stuck_with_you',
    title: 'Stuck With You',
    author: 'Ann Marie Walker & Weston Parker',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 87 * DAY,
  },
  {
    id: 'book_it_happened_one_summer',
    title: 'It Happened One Summer',
    author: 'Tessa Bailey',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 384,
    dateAdded: now - 86 * DAY,
  },
  {
    id: 'book_midnight_kisses',
    title: 'Midnight Kisses',
    author: 'Jeanine Bennedict',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 85 * DAY,
  },
  {
    id: 'book_murakami_novelist_as_a_vocation',
    title: 'Murakami - Novelist As A Vocation',
    author: 'Haruki Murakami',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 224,
    dateAdded: now - 84 * DAY,
  },
  {
    id: 'book_the_playlist',
    title: 'The Playlist',
    author: 'Morgan Elizabeth',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 350,
    dateAdded: now - 83 * DAY,
  },
  {
    id: 'book_thinking_fast_and_slow',
    title: 'Thinking Fast and Slow',
    author: 'Daniel Kahneman',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 499,
    dateAdded: now - 82 * DAY,
  },
  {
    id: 'book_the_summer_i_turned_pretty',
    title: 'The Summer I Turned Pretty',
    author: 'Jenny Han',
    tone: 'coral',
    genres: ['Young Adult'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 288,
    dateAdded: now - 81 * DAY,
  },
  {
    id: 'book_its_not_summer_without_you',
    title: 'Its Not Summer Without You',
    author: 'Jenny Han',
    tone: 'coral',
    genres: ['Young Adult'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 276,
    dateAdded: now - 80 * DAY,
  },
  {
    id: 'book_we_ll_always_have_summer',
    title: 'We\'ll Always Have Summer',
    author: 'Jenny Han',
    tone: 'coral',
    genres: ['Young Adult'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 293,
    dateAdded: now - 79 * DAY,
  },
  {
    id: 'book_arranged_hearts',
    title: 'Arranged Hearts',
    author: '',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 78 * DAY,
  },
  {
    id: 'book_before_your_memory_fades',
    title: 'Before Your Memory Fades',
    author: 'Toshikazu Kawaguchi',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 240,
    dateAdded: now - 77 * DAY,
  },
  {
    id: 'book_before_we_say_goodbye',
    title: 'Before we say goodbye',
    author: 'Toshikazu Kawaguchi',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 240,
    dateAdded: now - 76 * DAY,
  },
  {
    id: 'book_before_we_forget_kindness',
    title: 'Before we forget kindness',
    author: 'Toshikazu Kawaguchi',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 240,
    dateAdded: now - 75 * DAY,
  },
  {
    id: 'book_before_i_knew_i_loved_you',
    title: 'Before I knew I loved you',
    author: 'Toshikazu Kawaguchi',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 240,
    dateAdded: now - 74 * DAY,
  },
  {
    id: 'book_the_kamogawa_food_detectives',
    title: 'The kamogawa food detectives',
    author: 'Hisashi Kashiwai',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 240,
    dateAdded: now - 73 * DAY,
  },
  {
    id: 'book_what_you_are_looking_for_is',
    title: 'What you are looking for is in the library',
    author: 'Michiko Aoyama',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 272,
    dateAdded: now - 72 * DAY,
  },
  {
    id: 'book_a_touch_of_darkness',
    title: 'A Touch of Darkness',
    author: 'Scarlett St. Clair',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 328,
    dateAdded: now - 71 * DAY,
  },
  {
    id: 'book_the_shadow_between_us',
    title: 'The Shadow Between Us',
    author: 'Tricia Levenseller',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 70 * DAY,
  },
  {
    id: 'book_the_comfort_crisis',
    title: 'The Comfort Crisis',
    author: 'Michael Easter',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 304,
    dateAdded: now - 69 * DAY,
  },
  {
    id: 'book_the_crimson',
    title: 'The Crimson',
    author: 'Wendy Owens',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 300,
    dateAdded: now - 68 * DAY,
  },
  {
    id: 'book_mahagatha_100_tales_from_the_puranas',
    title: 'Mahagatha: 100 tales from the Puranas',
    author: 'Satyarth Nayak',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 67 * DAY,
  },
  {
    id: 'book_the_upside_of_falling',
    title: 'The Upside Of Falling',
    author: 'Alex Light',
    tone: 'coral',
    genres: ['Young Adult'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 66 * DAY,
  },
  {
    id: 'book_being_heard',
    title: 'Being Heard',
    author: '',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 200,
    dateAdded: now - 65 * DAY,
  },
  {
    id: 'book_all_he_ll_ever_be_series',
    title: 'Merciless',
    author: 'Shanora Williams',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 64 * DAY,
  },
  {
    id: 'book_dear_stranger_you_deserve_to_be',
    title: 'Dear Stranger, You Deserve To Be Loved',
    author: 'Ashish Bagrecha',
    tone: 'yellow',
    genres: ['Poetry'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 208,
    dateAdded: now - 63 * DAY,
  },
  {
    id: 'book_all_the_lights_we_cannot_see',
    title: 'All The Lights We Cannot See',
    author: 'Anthony Doerr',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 544,
    dateAdded: now - 62 * DAY,
  },
  {
    id: 'book_chasing_love',
    title: 'Chasing Love',
    author: 'Kat T. Masen',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 300,
    dateAdded: now - 61 * DAY,
  },
  {
    id: 'book_say_you_swear',
    title: 'Say You Swear',
    author: 'Meagan Brandy',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 380,
    dateAdded: now - 60 * DAY,
  },
  {
    id: 'book_furious_love',
    title: 'Furious Love',
    author: 'Sam Kashner & Nancy Schoenberger',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 672,
    dateAdded: now - 59 * DAY,
  },
  {
    id: 'book_the_hunger_games',
    title: 'The Hunger Games',
    author: 'Suzanne Collins',
    tone: 'coral',
    genres: ['Young Adult'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 374,
    dateAdded: now - 58 * DAY,
  },
  {
    id: 'book_eat_pray_love',
    title: 'Eat Pray Love',
    author: 'Elizabeth Gilbert',
    tone: 'yellow',
    genres: ['Memoir'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 352,
    dateAdded: now - 57 * DAY,
  },
  {
    id: 'book_charlotte_s_web',
    title: 'Charlotte\'s Web',
    author: 'E.B. White',
    tone: 'sage',
    genres: ['Classics'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 184,
    dateAdded: now - 56 * DAY,
  },
  {
    id: 'book_conversation_with_friends',
    title: 'Conversation with Friends',
    author: 'Sally Rooney',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 321,
    dateAdded: now - 55 * DAY,
  },
  {
    id: 'book_rebecca',
    title: 'Rebecca',
    author: 'Daphne du Maurier',
    tone: 'sage',
    genres: ['Classics'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 448,
    dateAdded: now - 54 * DAY,
  },
  {
    id: 'book_the_beautiful_and_damned',
    title: 'The Beautiful and Damned!',
    author: 'F. Scott Fitzgerald',
    tone: 'sage',
    genres: ['Classics'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 449,
    dateAdded: now - 53 * DAY,
  },
  {
    id: 'book_the_very_secret_society_of_irregular',
    title: 'The Very Secret Society of Irregular Witches',
    author: 'Sangu Mandanna',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 368,
    dateAdded: now - 52 * DAY,
  },
  {
    id: 'book_catch_22',
    title: 'Catch 22',
    author: 'Joseph Heller',
    tone: 'sage',
    genres: ['Classics'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 453,
    dateAdded: now - 51 * DAY,
  },
  {
    id: 'book_the_infernal_devices_book_series',
    title: 'The Infernal Devices Book Series',
    author: 'Cassandra Clare',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 496,
    dateAdded: now - 50 * DAY,
  },
  {
    id: 'book_the_burnout',
    title: 'The Burnout',
    author: 'Sophie Kinsella',
    tone: 'coral',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 49 * DAY,
  },
  {
    id: 'book_spin_the_bottle',
    title: 'Spin the Bottle',
    author: 'Stephanie Alves',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 300,
    dateAdded: now - 48 * DAY,
  },
  {
    id: 'book_a_gentleman_in_moscow',
    title: 'A Gentleman in Moscow',
    author: 'Amor Towles',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 462,
    dateAdded: now - 47 * DAY,
  },
  {
    id: 'book_book_1_book_of_azrael',
    title: 'Book 1 - Book of Azrael',
    author: 'Amber V. Nicole',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 46 * DAY,
  },
  {
    id: 'book_book_2_a_throne_of_broken',
    title: 'Book 2 - A Throne of Broken Gods',
    author: 'Amber V. Nicole',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 420,
    dateAdded: now - 45 * DAY,
  },
  {
    id: 'book_funny_feelings',
    title: 'Funny Feelings',
    author: 'Celia Laskey',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 336,
    dateAdded: now - 44 * DAY,
  },
  {
    id: 'book_my_dark_romeo',
    title: 'My Dark Romeo',
    author: 'Amy Daws',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 43 * DAY,
  },
  {
    id: 'book_seeker_of_nothing',
    title: 'Seeker of Nothing',
    author: 'Kabir Munjal',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 200,
    dateAdded: now - 42 * DAY,
  },
  {
    id: 'book_the_lost_art_of_doing_nothing',
    title: 'The lost art of doing nothing',
    author: '',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 200,
    dateAdded: now - 41 * DAY,
  },
  {
    id: 'book_alone_with_you_in_the_ether',
    title: 'Alone with you in the Ether',
    author: 'Olivie Blake',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 368,
    dateAdded: now - 40 * DAY,
  },
  {
    id: 'book_the_wandering_star',
    title: 'The Wandering Star',
    author: '',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 280,
    dateAdded: now - 39 * DAY,
  },
  {
    id: 'book_you_don_t_suck',
    title: 'You Don\'t Suck',
    author: 'Max Masure',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 200,
    dateAdded: now - 38 * DAY,
  },
  {
    id: 'book_palace_of_illusions',
    title: 'Palace of Illusions',
    author: 'Chitra Banerjee Divakaruni',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 360,
    dateAdded: now - 37 * DAY,
  },
  {
    id: 'book_the_idiot_brain',
    title: 'The idiot brain',
    author: 'Dean Burnett',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 304,
    dateAdded: now - 36 * DAY,
  },
  {
    id: 'book_hooked',
    title: 'Hooked!',
    author: 'Emily McIntire',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 350,
    dateAdded: now - 35 * DAY,
  },
  {
    id: 'book_black_ties_and_white_lies',
    title: 'Black Ties And White Lies',
    author: 'Kat Singleton',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 350,
    dateAdded: now - 34 * DAY,
  },
  {
    id: 'book_the_sun_is_also_a_star',
    title: 'The Sun Is Also A Star',
    author: 'Nicola Yoon',
    tone: 'coral',
    genres: ['Young Adult'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 384,
    dateAdded: now - 33 * DAY,
  },
  {
    id: 'book_hidden_hindu',
    title: 'Hidden Hindu',
    author: 'Akshat Gupta',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 300,
    dateAdded: now - 32 * DAY,
  },
  {
    id: 'book_the_heart_is_deceitful_above_all',
    title: 'The Heart is Deceitful Above All Things',
    author: 'J.T. LeRoy',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 288,
    dateAdded: now - 31 * DAY,
  },
  {
    id: 'book_blood_on_my_name',
    title: 'Blood On My Name',
    author: 'K. Elle Morrison',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 350,
    dateAdded: now - 30 * DAY,
  },
  {
    id: 'book_a_little_life',
    title: 'A little life',
    author: 'Hanya Yanagihara',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 720,
    dateAdded: now - 29 * DAY,
  },
  {
    id: 'book_she_was_only_mine',
    title: 'She was only mine',
    author: 'Abhinav Ojha',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 250,
    dateAdded: now - 28 * DAY,
  },
  {
    id: 'book_good_vibes_good_life',
    title: 'Good Vibes, Good Life',
    author: 'Vex King',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 288,
    dateAdded: now - 27 * DAY,
  },
  {
    id: 'book_fyodor_dostoyevsky_crime_and_punishment',
    title: 'Fyodor Dostoyevsky - Crime and Punishment',
    author: 'Fyodor Dostoevsky',
    tone: 'sage',
    genres: ['Classics'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 671,
    dateAdded: now - 26 * DAY,
  },
  {
    id: 'book_the_mountain_is_you',
    title: 'The mountain is YOU',
    author: 'Brianna Wiest',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 240,
    dateAdded: now - 25 * DAY,
  },
  {
    id: 'book_the_collected_regrets_of_clover',
    title: 'The collected regrets of clover',
    author: 'Mikki Brammer',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 320,
    dateAdded: now - 24 * DAY,
  },
  {
    id: 'book_the_hard_thing_about_hard_things',
    title: 'The hard thing about hard things',
    author: 'Ben Horowitz',
    tone: 'yellow',
    genres: ['Business'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 304,
    dateAdded: now - 23 * DAY,
  },
  {
    id: 'book_amazon_shareholder_letters',
    title: 'Amazon shareholder letters',
    author: 'Jeff Bezos',
    tone: 'yellow',
    genres: ['Business'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 300,
    dateAdded: now - 22 * DAY,
  },
  {
    id: 'book_samsara',
    title: 'Samsara',
    author: '',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 250,
    dateAdded: now - 21 * DAY,
  },
  {
    id: 'book_the_body_keeps_the_score',
    title: 'The body keeps the score',
    author: 'Bessel van der Kolk',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 464,
    dateAdded: now - 20 * DAY,
  },
  {
    id: 'book_white_nights',
    title: 'White nights',
    author: 'Fyodor Dostoevsky',
    tone: 'sage',
    genres: ['Classics'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 96,
    dateAdded: now - 19 * DAY,
  },
  {
    id: 'book_men_without_women',
    title: 'Men without women',
    author: 'Haruki Murakami',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 256,
    dateAdded: now - 18 * DAY,
  },
  {
    id: 'book_set_on_you',
    title: 'Set on you',
    author: 'Amy Lea',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 17 * DAY,
  },
  {
    id: 'book_the_secret_diary_of_adrian_mole',
    title: 'The secret diary of adrian mole',
    author: 'Sue Townsend',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 256,
    dateAdded: now - 16 * DAY,
  },
  {
    id: 'book_the_midnight_library',
    title: 'The midnight library',
    author: 'Matt Haig',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 304,
    dateAdded: now - 15 * DAY,
  },
  {
    id: 'book_the_will_of_the_many',
    title: 'The will of the many',
    author: 'James Islington',
    tone: 'blue',
    genres: ['Fantasy'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 560,
    dateAdded: now - 14 * DAY,
  },
  {
    id: 'book_in_the_silence_you_left_behind',
    title: 'In the silence you left behind',
    author: 'Sumitra Manda',
    tone: 'yellow',
    genres: ['Poetry'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 176,
    dateAdded: now - 13 * DAY,
  },
  {
    id: 'book_will_you_love_me_anyway',
    title: 'Will you love me anyway?',
    author: 'Mitali Meelan',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 300,
    dateAdded: now - 12 * DAY,
  },
  {
    id: 'book_why_men_love_bitches',
    title: 'Why men love bitches',
    author: 'Sherry Argov',
    tone: 'yellow',
    genres: ['Nonfiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 240,
    dateAdded: now - 11 * DAY,
  },
  {
    id: 'book_problematic_summer_romance',
    title: 'Problematic summer romance',
    author: 'Ali Hazelwood',
    tone: 'coral',
    genres: ['Romance'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 384,
    dateAdded: now - 10 * DAY,
  },
  {
    id: 'book_honey',
    title: 'Honey',
    author: 'Azrael Kass',
    tone: 'yellow',
    genres: ['Poetry'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 180,
    dateAdded: now - 9 * DAY,
  },
  {
    id: 'book_the_girl_with_a_dragon_tattoo',
    title: 'The girl with a dragon tattoo',
    author: 'Stieg Larsson',
    tone: 'blue',
    genres: ['Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 480,
    dateAdded: now - 8 * DAY,
  },
  {
    id: 'book_the_girl_who_played_with_fire',
    title: 'The girl who played with fire',
    author: 'Stieg Larsson',
    tone: 'blue',
    genres: ['Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 512,
    dateAdded: now - 7 * DAY,
  },
  {
    id: 'book_the_girl_who_kicked_hornets_nest',
    title: 'The girl who kicked hornets nest',
    author: 'Stieg Larsson',
    tone: 'blue',
    genres: ['Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 563,
    dateAdded: now - 6 * DAY,
  },
  {
    id: 'book_for_one_more_day',
    title: 'For one more day',
    author: 'Mitch Albom',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 197,
    dateAdded: now - 5 * DAY,
  },
  {
    id: 'book_the_giving_tree',
    title: 'The giving tree',
    author: 'Shel Silverstein',
    tone: 'sage',
    genres: ['Classics'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 64,
    dateAdded: now - 4 * DAY,
  },
  {
    id: 'book_dear_to_saturn',
    title: 'Dear to Saturn',
    author: 'Merlin Senthil',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 220,
    dateAdded: now - 3 * DAY,
  },
  {
    id: 'book_not_quite_dead_yet',
    title: 'Not quite dead yet',
    author: 'Holly Jackson',
    tone: 'blue',
    genres: ['Thriller'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 400,
    dateAdded: now - 2 * DAY,
  },
  {
    id: 'book_normal_people',
    title: 'Normal People',
    author: 'Sally Rooney',
    tone: 'sage',
    genres: ['Fiction'],
    status: 'tbr',
    isFavorite: false,
    rating: null,
    totalPages: 273,
    dateAdded: now - 1 * DAY,
  },
];

/**
 * Small discoverable catalog for the "Add Book" search step — stands in
 * for a real book-search endpoint.
 */
export const DISCOVERABLE_BOOKS = [
  { id: 'disc_tomorrow', title: 'Tomorrow, and Tomorrow, and Tomorrow', author: 'Gabrielle Zevin', tone: 'coral', genres: ['Fiction', 'Contemporary'], totalPages: 416 },
  { id: 'disc_atlas_six', title: 'The Atlas Six', author: 'Olivie Blake', tone: 'blue', genres: ['Fantasy', 'Dark Academia'], totalPages: 400 },
  { id: 'disc_song_achilles', title: 'The Song of Achilles', author: 'Madeline Miller', tone: 'yellow', genres: ['Classics', 'Fantasy'], totalPages: 416 },
  { id: 'disc_bear_nightingale', title: 'The Bear and the Nightingale', author: 'Katherine Arden', tone: 'blue', genres: ['Fantasy', 'Historical Fiction'], totalPages: 384 },
  { id: 'disc_klara_sun', title: 'Klara and the Sun', author: 'Kazuo Ishiguro', tone: 'sage', genres: ['Science Fiction', 'Literary Fiction'], totalPages: 320 },
  { id: 'disc_iron_widow', title: 'Iron Widow', author: 'Xiran Jay Zhao', tone: 'coral', genres: ['Science Fiction', 'Romance'], totalPages: 400 },
  { id: 'disc_this_time', title: 'This Time Tomorrow', author: 'Emma Straub', tone: 'yellow', genres: ['Fiction', 'Contemporary'], totalPages: 320 },
  { id: 'disc_locked_doors', title: 'The Ten Thousand Doors of January', author: 'Alix E. Harrow', tone: 'sage', genres: ['Fantasy', 'Adventure'], totalPages: 400 },
];
